// extracted by mini-css-extract-plugin
export var button = "_dj-4";
export var hasDarkBackground = "_dj-7";
export var hasLightBackground = "_dj-6";
export var iconWrapper = "_dj-0";
export var large = "_dj-2";
export var medium = "_dj-1";
export var small = "_dj-5";
export var xsmall = "_dj-3";